class CustomerService extends HTMLElement {
    constructor() {
        super();
        this.querySelector("#customer-service-overlay")
            .addEventListener("click", this.close.bind(this));
    }

    connectedCallback() {
        this.addEventListener("keyup", event => {
            if (event.code.toUpperCase() === "ESCAPE") this.close();
        });

        this.querySelector("#customer-service-icon-close")
            .addEventListener("click", () => this.close());

        const trigger = document.querySelector(".header__utils-item--contact .header__utils-link--icon");

        trigger.setAttribute("tabindex", "0");
        trigger.setAttribute("role", "button");
        trigger.setAttribute("aria-label", "Open customer service");

        trigger.addEventListener("click", () => this.open());

        trigger.addEventListener("keydown", (event) => {
            if (event.code === "Enter" || event.code === "Space") {
                event.preventDefault();
                this.open();
            }
        });
    }

    open() {
        this.classList.add("cs-isVisible");
    }

    close() {
        this.classList.remove("cs-isVisible");
    }
}

customElements.define('customer-service', CustomerService);






    (function () {
  function onFirstTab(e) {
    if (e.key === 'Tab') {
      document.body.classList.add('user-is-tabbing');
      window.removeEventListener('keydown', onFirstTab);
      window.addEventListener('mousedown', onMouse);
      window.addEventListener('touchstart', onMouse, {passive:true});
    }
  }
  function onMouse() {
    document.body.classList.remove('user-is-tabbing');
    window.removeEventListener('mousedown', onMouse);
    window.removeEventListener('touchstart', onMouse);
    window.addEventListener('keydown', onFirstTab);
  }
  window.addEventListener('keydown', onFirstTab);
})();
